import { _ } from "../../core/polyglot/polyglot.js";
import externalDocument from "../shared/externalDocument.js";

/**
 *	`passwordResetDocument' is the document used after a reset
 *	password request. See `passwordResetWidget` for more details.
 */

/**
 * Todo: Add JSDoc comment
 */
function passwordResetDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = externalDocument(spec, my);

	that.title = _("New password sent!");

	my.renderContentOn = function (html) {
		html.div({ id: "document-title" }, html.h1(that.title));

		html.div(
			{ class: "row" },
			html.div(
				{
					class: "col-lg-4 col-lg-offset-4 col-sm-6 col-sm-offset-3 text-center",
				},
				html.p(
					{ class: "lead" },
					_(
						"An email with the new password has been sent to the address on record. If you do not receive one shortly, please contact the Administrator. When you get it, try and {link: log in again}",
						{
							link: (value) =>
								html.a(
									{ href: my.linkTo("migrate", {}) },
									value,
								),
						},
					),
				),
			),
		);
	};

	return that;
}

export default passwordResetDocument;
